import { cityTimezones } from "common/constants";

export const checkIsEmbededEnvironment = (): boolean => {
    const host = window.location.host;
    const stage_origin = 'goldlive-8ca30.uc.r.appspot.com'; 
    const prod_origin_prev = 'kitco-widgets.uc.r.appspot.com';
    const prod_origin = 'widgets.kitco.com'; 
    const localhost = 'localhost:3000'; 

    //TODO: remove this line when deploying to production
/*      if(host === localhost) {
      return true;    
    }     */

    if(host !== stage_origin && host !== prod_origin && host !== prod_origin_prev && host !== localhost) {
        return true;
    } else {
        return false;
    }
}

export const getCurrentDateFormatted = (): string => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); 
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const isToday = (dateStr: string) => {
    const todayStr = new Date().toLocaleDateString('en-CA'); 
    return dateStr === todayStr;
  };
  

export const arrayToMapBase = (array: any[], key: string) =>
    array?.reduce(
      (acc, item) => ({
        ...acc,
        [item[key]]: item,
      }),
      {},
  );

export const arrayToMap = (array: any[], key: string) =>
    array?.reduce(
      (acc, item) => ({
        ...acc,
        [item[key]]: [...(acc[item[key]] || []), item],
      }),
      {},
  );

  export const mapArrayByTimestamp = (array: any[], key: string) =>
    array?.reduce(
        (acc, item) => {
            const dateKey = item[key]?.split(' ')[0]; // Extract the date portion (e.g., '2025-06-13')
            if (!dateKey) return acc; // Skip if the key is invalid or undefined
            return {
                ...acc,
                [dateKey]: [...(acc[dateKey] || []), item],
            };
        },
        {},
    );

    export function getLocalTimesForCities(
      cities: CitiesLondonFix[],
      now: Date = new Date()
    ): Record<string, string> {    
      console.log('Current UTC time:', now);
      const result: Record<string, string> = {};
    
      for (const city of cities) {
        const tz = cityTimezones[city.standart_time];
    
        // Get current date and time in that timezone
        const localeTime = new Intl.DateTimeFormat('en-US', {
          timeZone: tz,
          hour12: false,
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        }).formatToParts(now);
    
        const getPart = (type: string) => localeTime.find(p => p.type === type)?.value || '0';
    
        const cityYear = +getPart('year');
        const cityMonth = +getPart('month') - 1; 
        const cityDate = +getPart('day');
        const cityHour = +getPart('hour');
        const cityMinute = +getPart('minute');
        const citySecond = +getPart('second');
    
        // Build the city's current local time
        const cityCurrent = new Date(Date.UTC(cityYear, cityMonth, cityDate, cityHour, cityMinute, citySecond));
    
        // Build target time: today 10:30 AM in that timezone
        let target = new Date(Date.UTC(cityYear, cityMonth, cityDate, 10, 30, 0));
    
        if (cityCurrent >= target) {
          // If already past 10:30 AM there, move to next day
          target.setUTCDate(target.getUTCDate() + 1);
        }
    
        // Convert both to UTC timestamps and get the diff
        const diffMs = target.getTime() - cityCurrent.getTime();
    
        const totalMinutes = Math.floor(diffMs / 60000);
        const hours = String(Math.floor(totalMinutes / 60)).padStart(2, '0');
        const minutes = String(totalMinutes % 60).padStart(2, '0');
    
        result[city.name] = `${hours}h:${minutes}min`;
      }
    
      return result;
    }
    
    
    

